<template>
  <div>
    <Head />

    <div class="wrapper sign_up">
      <section class="main">
        <div class="container">
          <!-- <h1>2023年經濟部綠色盒餐徵選</h1> -->
          <div class="img_box">
            <div class="img">
              <img v-if="ProjectData && ProjectData.Project && ProjectData.Project.Image" :src="ProjectData.SiteUrl + ProjectData.Project.Image" alt="">
              <img v-else src="img/sample-2.png" alt="">
            </div>
          </div>
          <div class="box">
            <h2>委員登入</h2>
            <div class="form-group">
              <label for="">帳號</label>
              <input type="" class="form-control" id="" aria-describedby="" placeholder="請輸入帳號" v-model="Account">
            </div>
            <div class="form-group">
              <label for="">密碼</label>
              <input type="password" class="form-control" id="" aria-describedby="" placeholder="請輸入密碼"
                v-model="Password">
            </div>
            <div class="btn_box">
              <button @click="login()">登入</button>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "LoginForReviewer",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      ProjectData: {},
      Account: "",
      Password: "",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/GetOngoingProject",
        {
          params: {
            lang: $cookies.get("is_site_lang")
          },
        }
      )
      .then((response) => {
        this.ProjectData = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    let that = this;
    setTimeout(() => {
      that.badgeStyle = document.createElement('style');
      that.badgeStyle.innerText = '.grecaptcha-badge { display: block !important; visibility: visible !important; opacity: 1 !important; }';
      that.badgeStyle.id = 'show-recaptcha-badge';
      document.head.appendChild(that.badgeStyle);
    }, 500);
  },
  updated: function () {
  },
  methods: {
    async getRecaptchaToken() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch {
        Swal.fire({
          title: "錯誤",
          text: "請確認網路環境後再試一次（RG）",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return null;
      }
    },
    async login() {
      if (this.Account == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入帳號",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      if (this.Password == "") {
        Swal.fire({
          title: "錯誤",
          text: "請輸入密碼",
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: "確定",
          heightAuto: false,
        });
        return;
      }
      // 我不是機器人
      let recaptchaToken = await this.getRecaptchaToken();
      if (!recaptchaToken) {
        return;
      }
      // 顯示請稍候
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 組合並送出
      let token = AES.encrypt(this.Account + "|" + this.Password + "|" + recaptchaToken);
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/LoginForReviewer",
        type: "post",
        data: {
          token: token,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            $cookies.set("is_login_token", res.LoginToken, "30d");
            Swal.fire({
              title: "登入成功",
              text: "即將返回首頁",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                if (that.$route.fullPath == "/") {
                  location.reload();
                } else {
                  that.$router.push({
                    name: "RatingHome",
                  });
                }
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        },
      });
    },
  },
};
</script>
